import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-showers.svg";
import * as styles from "./Icon.module.scss";

type WeatherShowersProps = React.SVGProps<SVGSVGElement>;

export const WeatherShowers = ({ className, ...props }: WeatherShowersProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
